import calculatorEventBus from 'apps/bankrate-calculators/events'

export default {
  computed: {
    showAmortization() {
      return this.$store.state.showAmortizationSchedule
    },
    monthlyPayment() {
      return this.$store.state.monthlyPayment
    },
    totalPrincipalPaid() {
      return this.$store.state.totalPrincipalPaid
    },
    totalInterest() {
      return this.$store.state.totalInterest
    },
    errorsOnPage() {
      return this.$store.getters.pageHasErrors
    }
  },
  methods: {
    rebuildAmortization() {
      calculatorEventBus.$emit('calculator:calculation')

      if (this.$refs.amortization) {
        this.$refs.amortization.updateAmortizationSchedule()
      }
    },
    toggleAmortizationSchedule(event) {
      this.$store.dispatch('toggleAmortizationSchedule', { event })
    },
    trackRateRequest() {
      calculatorEventBus.$emit('calculator:requestRateTable')
    }
  }
}
